// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;500;600;700&display=swap);"]);
// Module
exports.push([module.id, ".eos-meeting__conclude-ratings__input[data-v-2c62133c]{width:150px}.eos-meeting__conclude-ratings__avatar[data-v-2c62133c]{width:20px}.eos-meeting__conclude-ratings__attendee[data-v-2c62133c]{width:200px}.eos-meeting__btn-vote--invisible[data-v-2c62133c]{visibility:hidden}", ""]);
// Exports
module.exports = exports;
